import { render, staticRenderFns } from "./EventSpaceV2.vue?vue&type=template&id=051d1ec5&"
import script from "./EventSpaceV2.vue?vue&type=script&lang=js&"
export * from "./EventSpaceV2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports